<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center center">
      <Teranet-PageTitle [PageTitle]="'Password Recovery Security Questions'"></Teranet-PageTitle>
      <form #userFormRef="ngForm" (ngSubmit)="onSubmit()">
        <mat-list>
          <mat-list-item *ngFor="let item of passwordRecoveryList">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">{{ item.question }}</mat-label>
              <mat-form-field class="mat-form-field-lg" appearance="outline">
                <input matInput data-lpignore="true"
                       [(ngModel)]="item.answer" id="{{ item.setId }}" name="{{ item.setId }}" required />
              </mat-form-field>
            </div>
          </mat-list-item>
        </mat-list>
        <div fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="plain-button" type="reset" (click)="onCancel()">Cancel</button>
          <button mat-raised-button class="theme-button" type="submit" [disabled]="!userFormRef.form.valid">Submit</button>
        </div>
      </form>
      <div>
        <div *ngIf="isError" class="alert alert-danger" role="alert">
          <div>{{ errorMessage }}</div>
        </div>
        <div *ngIf="(isError != undefined) && !isError" class="alert alert-success" role="alert">
          The link has been sent, please check your email to reset your password.
        </div>
      </div>
    </div>
  </div>
</div>
